/**
 * Telemetria mínima de erros do painel.
 *
 * Fire-and-forget: nunca lança, nunca bloqueia o render e não usa a instância
 * axios (o próprio fluxo de auth/axios pode ser a origem do erro reportado).
 * Sem imports de outros módulos do app para não criar ciclo no caminho de erro.
 */

const ENDPOINT = `${process.env.REACT_APP_API_URL}/frontend-errors`;
const MAX_REPORTS_PER_SESSION = 10;

const reportedKeys = new Set();

const safeGet = (fn, fallback) => {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
};

export default function reportError({ type, message, stack, componentStack }) {
  try {
    const normalizedMessage = String(message || "").slice(0, 1000);
    const dedupeKey = `${type}|${normalizedMessage.slice(0, 200)}`;
    if (reportedKeys.has(dedupeKey) || reportedKeys.size >= MAX_REPORTS_PER_SESSION) return;
    reportedKeys.add(dedupeKey);

    const payload = {
      type: String(type || "unknown").slice(0, 50),
      message: normalizedMessage,
      stack: String(stack || "").slice(0, 5000),
      component_stack: String(componentStack || "").slice(0, 5000),
      url: safeGet(() => window.location.href, ""),
      user_agent: safeGet(() => navigator.userAgent, ""),
      build_version: process.env.REACT_APP_VERSION || "dev",
      // Chaves literais de src/services/auth.js (sem import — ver nota acima).
      user_id: safeGet(() => localStorage.getItem("@MeuML-UserId"), null),
      user_email: safeGet(() => localStorage.getItem("@MeuML-UserEmail"), null),
      // Somente as CHAVES do storage, nunca os valores (o token fica fora).
      storage_keys: safeGet(() => Object.keys(localStorage).join(","), "").slice(0, 2000),
    };

    // keepalive: o POST sobrevive ao window.location.reload() do retry de chunk.
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // O reporter jamais pode derrubar o app.
  }
}
